<script setup>
import { computed } from 'vue'

const props = defineProps({
  message: {
    type: Object,
    required: true
  },
  chatId: {
    type: String,
    required: true
  },
  chatUser: {
    type: Object,
    required: true
  }
})

const imagePreview = computed(() => {
  if (props.message.parent?.attachment) {
    return props.message.parent.attachment.fields.links.c160x160
  } else if (props.message.parent?.post) {
    return props.message.parent?.post.previewImageUrl
  } else {
    return null
  }
})

function scrollToReply () {
  const messageId = props.message?.parent.messageId
  if (!messageId) return

  const element = document.getElementById(messageId)
  if (!element) return

  element.scrollIntoView({ behavior: 'smooth', block: 'center' })

  element.classList.add('shake-reply')

  setTimeout(() => {
    element.classList.remove('shake-reply')
  }, 600)
}
</script>

<template>
  <blockquote
    v-if="message.parent"
    class="blockquote border-l-[8px] rounded-md mb-2 px-2 py-1.5 flex gap-2 cursor-pointer"
    @click.stop="scrollToReply">
    <img
      v-if="imagePreview"
      :src="imagePreview"
      class="w-10 h-10 object-cover rounded"
      alt="">

    <div>
      <h3 class="text-[14px] font-normal">
        {{ message.parent.senderId === chatId ? chatUser.name : $t('common.you') }}
      </h3>

      <p class="text-gray-500 leading-relaxed text-xs">
        {{ message.parent?.text }}
      </p>
    </div>
  </blockquote>
</template>

<style scoped>
  .blockquote {
    background: #f0f0f0;
    border-color: #d0d0d0;
    color: #626774;
  }
  .blockquote h3 {
    color: #555555;
  }

  .me .blockquote {
    background: #93d9ea;
    border-color: #3978ba;
    color: #626774;
  }
  .me .blockquote h3 {
    color: #0284C7;
  }

  .me.need-pay .blockquote {
    background: #f9a9a9;
    border-color: #e4042f;
    color: #762424;
  }
  .me.need-pay .blockquote h3 {
    color: #e80e38;
  }

  .me.highlighted .blockquote {
    background: #f9a9a9;
    border-color: #e4042f;
    color: #762424;
  }
  .me.highlighted .blockquote h3 {
    color: #e80e38;
  }
</style>